import ENDPOINTS from "@app/constants/endpoints"
import { fetchWithValidation } from "@app/helpers/fetchWithValidation"
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import client from "../../../helpers/client"
import { type Offers, OffersSchema } from "../models/offers"

export const refreshOffers = async (): Promise<{
  success: boolean
  msg: string
}> => {
  const { data } = await client.post(`${ENDPOINTS.OFFERS}/refresh`)
  return data
}

export const useOffers = () => {
  return useQuery<Offers, Error>({
    queryKey: ["offers"],
    queryFn: () => fetchWithValidation(ENDPOINTS.OFFERS, OffersSchema),
    staleTime: 1000 * 60 * 10, // 10 minute
  })
}

export const useRefreshOffers = () => {
  const qc = useQueryClient()
  const mutation = useMutation({
    mutationFn: refreshOffers,
    onSuccess: () => qc.invalidateQueries({ queryKey: ["offers"] }),
  })
  return {
    refreshOffers: mutation.mutate,
    refreshing: mutation.status === "pending",
  }
}

export default useOffers
